<script setup lang="ts">
import { defineProps } from "vue";

type Props = {
  buttonText: string;
};

defineProps<Props>();
</script>

<template>
  <button
    class="bg-transparent w-[150px] rounded-primary-radius p-3 flex items-center justify-center border-2 border-primary-text-color"
  >
    <div class="flex items-center gap-2">
      <img src="@/assets/prev-btn-arrow-left.svg" alt="Warning icon" />
      <span
        class="text-primary-text-color text-base leading-5 tracking-[0.01rem] font-semibold"
      >
        {{ buttonText }}
      </span>
    </div>
  </button>
</template>
